module.exports = __webpack_public_path__ + "static/media/baby.dcb9e015.png";